import { Box } from "@chakra-ui/react";
import { AppCodeQRCode } from "../settings/AppCodeQRCode";

export const AdminPanel = () => {
  return (
    <Box display={"flex"} flexDir={"column"} alignItems={"center"}>
      <AppCodeQRCode />
    </Box>
  );
};
